import React, {useMemo} from 'react';
import {DASH_BREAKPOINTS} from "../../../../utils/responsive-graph.js";
import useGraphViewportWidth from "../../../../hooks/use-graph-viewport-width.js";
import clsx from "clsx";

const DutyProgressBar = ({data, total = 0, className = ""}) => {
    const vw = useGraphViewportWidth();
    const isCompact = vw < DASH_BREAKPOINTS.desktop;

    const value = useMemo(() => {
        return Object.entries(data).reduce((acc, [_, values]) => acc + (values?.delayed || 0), 0);
    }, [data]);

    const pct = total > 0 ? Math.min(100, (value / total) * 100) : 0;
    const pctLabel = `${Math.round(pct)}%`;

    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            <h3 className={"text-white whitespace-nowrap m-0 text-(length:--font-md)!"}>Em espera atrasados</h3>

            <div className="flex items-center gap-(--dash-gap-sm)">
                <div className="flex-1 h-[clamp(0.875rem,1.2vw,1.5rem)] rounded-full bg-white/10 overflow-hidden relative">
                    <div
                        className="h-full rounded-full flex items-center justify-end pr-2 relative z-10"
                        style={{
                            width: `${pct}%`,
                            minWidth: value > 0 ? '2rem' : 0,
                            background:
                                'linear-gradient(98.42deg, #003878 9.24%, #0080ED 51.01%, #3E98D9 74.98%, #1CEAE6 89.28%)'
                        }}
                    />
                </div>

                <span className="text-(length:--font-sm) shrink-0 min-w-[3ch] text-right">{pctLabel}</span>
            </div>
        </div>
    );
};

export default DutyProgressBar;